import React from 'react';
import styled from 'styled-components';
import GiftCardOverviews from './Overviews';
import GiftCardTable, { ITableGiftCardsProps } from './GiftCardTable';
interface Props extends ITableGiftCardsProps { }
const GiftCardsV2 = ({setSearchText ,handleSearch, handleChangeResetTime, onReset, resetTimeChecked, setResetTimeChecked, PAGE_SIZE, resetTime, searchText, status, setStatus }: Props) => {
  return (
    <Wrapper>
      <Container>
        <GiftCardOverviews />
        <GiftCardTable
          status={status}
          setStatus={setStatus}
          resetTime={resetTime}
          searchText={searchText}
          pageSize={PAGE_SIZE}
          resetTimeChecked={resetTimeChecked}
          setResetTimeChecked={setResetTimeChecked}
          handleChangeResetTime={handleChangeResetTime}
          onReset={onReset}
          handleSearch={handleSearch}
          setSearchText={setSearchText}
        />
      </Container>
    </Wrapper>
  );
};

export default GiftCardsV2;
const Container = styled.div`
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 16px;
padding: 16px;
background: #F6F7FC;
overflow-y: auto;
`;
const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;